import React from "react"
import { Col, Row, Table } from "react-bootstrap"
import FormatDate from "../../../../formatters/FormatDate"
import AccordionCard from "./AccordionCard"
import TestCardProps from "./TestCardProps"

export default function BATResultCard(props: TestCardProps) {
  const { data } = props
  const showConfirm = data.ConfirmLevel > 0.02
  const title = <Row>
    <Col xs={5} sm={3}>BAT RESULT DETAIL</Col>
    <Col xs={3} sm={5}>{data.DateCollected ? data.CollectionStatusDescription : ""}</Col>
    <Col xs={4} sm={4}>{data.DateCollected ? FormatDate(data.DateCollected) : ""}</Col>
  </Row>
  return (
    <AccordionCard eventKey="BATResultDetail" title={title}>
      <Table bordered className="bat-table">
        <thead>
            <tr>
                <th scope="col" className="col-md-3">INITIAL SCREENING</th>
                <th scope="col" className="col-md-3"></th>
                {showConfirm && <th scope="col" className="col-md-3">CONFIRMATION SCREENING</th>}
                {showConfirm && <th scope="col" className="col-md-3"></th>}
            </tr>
        </thead>
        <tbody>
          <tr>
              <td>DEVICE NAME</td>
              <td>{data.ScreenDeviceDescription}</td>
              {showConfirm && <td>DEVICE NAME</td>}
              {showConfirm && <td>{data.ConfirmDeviceDescription}</td>}
          </tr>
          <tr>
              <td>DEVICE SERIAL NUMBER</td>
              <td>{data.ScreenDeviceSerialNumber}</td>
              {showConfirm && <td>DEVICE SERIAL NUMBER</td>}
              {showConfirm && <td>{data.ConfirmDeviceSerialNumber}</td>}
          </tr>
          <tr>
              <td>TEST NUMBER</td>
              <td>{data.ScreenSequence}</td>
              {showConfirm && <td>TEST NUMBER</td>}
              {showConfirm && <td>{data.ConfirmSequence}</td>}
          </tr>
          <tr>
              <td>SCREENING-LEVEL</td>
              <td>{data.ScreenLevel}</td>
              {showConfirm && <td>SCREENING-LEVEL</td>}
              {showConfirm && <td>{data.ConfirmLevel}</td>}
          </tr>
        </tbody>
      </Table>
    </AccordionCard>
  )
}
